import { motion, useInView } from 'framer-motion';
import { useRef } from 'react';

export default function VideoTestimonal() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px',
  });

  const titleVariants = {
    hidden: { opacity: 0, y: 50, scale: 0.9 },
    visible: {
      opacity: 1,
      y: 0,
      scale: 1,
      transition: {
        duration: 0.6,
        ease: 'easeOut',
        delay: 0.2,
      },
    },
  };

  const containerVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.4,
        ease: 'easeOut',
        delay: 0.2,
      },
    },
  };

  const textVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.4,
        ease: 'easeOut',
        delay: 0.4,
      },
    },
  };

  const imageVariants = {
    hidden: { opacity: 0, scale: 0.95, y: 30 },
    visible: {
      opacity: 1,
      scale: 1,
      y: 0,
      transition: {
        duration: 0.4,
        ease: 'easeOut',
        delay: 0.6,
      },
    },
  };

  return (
    <section className="video_test my-4" ref={ref}>
      <motion.div
        className="bg-black rounded-2xl py-10 text-white flex flex-col items-center justify-center px-6 lg:px-0"
        variants={containerVariants}
        initial="hidden"
        animate={isInView ? 'visible' : 'hidden'}
      >
        <motion.h1
          variants={titleVariants}
          initial="hidden"
          animate={isInView ? 'visible' : 'hidden'}
          className="max-w-2xl lg:max-w-lg text-3xl lg:text-5xl pt-4 lg:pt-6 text-center tracking-normal font-medium"
        >
          This is what{' '}
          <span className="font-serif italic text-primary-light-7 font-semibold">
            Growth
          </span>{' '}
          looks like.
        </motion.h1>

        <motion.p
          className="lg:max-w-xl text-center pt-2 pb-4 lg:pt-6 lg:pb-6 text-light-grey-1 text-sm md:text-lg font-medium"
          variants={textVariants}
          initial="hidden"
          animate={isInView ? 'visible' : 'hidden'}
        >
          Step inside our world, where women dream, build, pitch, grow together
          and thriving through Shecluded's programs and community.
        </motion.p>

        {/* <div className="video-embed-container"> */}
        {/* <video src={"https://shecluded-medias.s3.us-east-2.amazonaws.com/testimonial_video.mp4"} controls className="w-auto h-[300px] lg:h-[400px]"></video> */}
        {/* </div> */}

        <motion.div
          className="img-container-comm w-full lg:w-3/4 h-[200px] p-[5px] lg:h-[480px] bg-gradient-to-r from-[#101010] via-[#EB2590] to-[#101010] rounded-2xl lg:rounded-3xl"
          variants={imageVariants}
          initial="hidden"
          animate={isInView ? 'visible' : 'hidden'}
        >
          <div
            className="w-full h-full rounded-2xl lg:rounded-3xl"
            style={{
              backgroundImage: `linear-gradient(to bottom, rgba(0, 0, 0, 0.2) 100%, rgba(0, 0, 0, 0.9) 100%), url('https://shecluded-medias.s3.us-east-2.amazonaws.com/comm-women.png')`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
            }}
          ></div>
        </motion.div>
      </motion.div>
    </section>
  );
}
